import { render } from "./EditEventButton.vue?vue&type=template&id=67accffc"
import script from "./EditEventButton.vue?vue&type=script&lang=js"
export * from "./EditEventButton.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__